<script lang="ts" setup>
import { useVModel } from "@vueuse/core"
import BaseInputWrapper from "./BaseInputWrapper.vue"

type Props = {
    inputId: string
    name: string
    label?: string
    error?: string
    hint?: string
    invalid?: boolean
    options: any[]
    optionLabel: string
    optionValue: string

    radio?: boolean
    horizontal?: boolean

    modelValue: any[] | any
}

const emit = defineEmits(["update:modelValue"])

const props = withDefaults(defineProps<Props>(), {
    options: () => [],
    optionLabel: "label",
    optionValue: "value",
    modelValue: () => [],
    inputId: "",
    label: "",
    error: "",
    hint: "",
    invalid: false,
    name: "",
    radio: false,
    horizontal: false,
})

const modelValue = useVModel(props, "modelValue", emit, {
    eventName: "update:modelValue",
})
</script>
<template>
    <BaseInputWrapper
        :label="label"
        :error="error"
        :hint="hint"
        :input-id="inputId"
        class="base-checkbox-list"
    >
        <div
            :class="[
                'base-checkbox-list__wrapper',
                horizontal && 'base-checkbox-list__wrapper--horizontal',
            ]"
        >
            <div
                class="flex flex-col gap-2"
                v-for="option in options"
                :key="option[optionValue]"
            >
                <div class="flex items-center gap-2">
                    <BaseCheckbox
                        v-if="!radio"
                        v-model="modelValue"
                        :input-id="`${inputId}_${option[optionValue]}`"
                        :name="`${inputId}_name`"
                        :value="option[optionValue]"
                    />
                    <BaseRadioButton
                        v-else
                        v-model="modelValue"
                        :input-id="`${inputId}_${option[optionValue]}`"
                        :name="`${inputId}_name`"
                        :value="option[optionValue]"
                    />
                    <label
                        :for="`${inputId}_${option[optionValue]}`"
                        class="cursor-pointer"
                        >{{ option[optionLabel] }}</label
                    >
                </div>
                <slot
                    :name="`option-${option[optionValue]}`"
                    :option="option"
                ></slot>
            </div>
        </div>
    </BaseInputWrapper>
</template>

<style scoped>
.base-checkbox-list {
    gap: 1rem;
    .base-input-wrapper {
        gap: 1rem;
    }
    label {
        color: var(--p-primary-800);
        font-weight: 400;
    }

    .base-checkbox-list__wrapper {
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }

    .base-checkbox-list__wrapper--horizontal {
        flex-direction: row;
        flex-wrap: wrap;
        gap: 2rem;
    }
}
</style>
